import { useState } from 'react';
import './GameScreen.css';
import './NameEntry.css';

function NameEntry({ onConfirm }) {
  const [name, setName] = useState('Player');

  function handleConfirm() {
    const trimmed = name.trim() || 'Player';
    onConfirm(trimmed);
  }

  function handleKeyDown(e) {
    if (e.key === 'Enter') handleConfirm();
  }

  return (
    <div className="game-screen">
      <div className="game-header" />
      <div className="game-info" />

      <div className="game-body name-entry-body">
        <label className="name-entry-label">Enter Name</label>
        <input
          className="name-entry-input"
          type="text"
          value={name}
          onChange={e => setName(e.target.value)}
          onKeyDown={handleKeyDown}
          maxLength={24}
          autoFocus
        />
      </div>

      <div className="game-middle" />

      <div className="game-bottom">
        <div className="action-log-wrapper" />

        <div className="game-actions-bar">
          <span className="bar-label">Actions</span>
          <div className="bar-buttons">
            <button className="action-btn" onClick={handleConfirm}>Confirm</button>
          </div>
        </div>

        <div className="game-move-bar greyed">
          <span className="bar-label">Move</span>
          <div className="bar-buttons" />
        </div>

        <div className="game-menu-bar greyed">
          <span className="bar-label">Menu</span>
          <div className="bar-buttons">
            <button className="menu-btn" disabled>Stats</button>
            <button className="menu-btn" disabled>Inventory</button>
            <button className="menu-btn" disabled>Party</button>
            <button className="menu-btn" disabled>Map</button>
            <button className="menu-btn quit-btn" disabled>Quit</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NameEntry;
